import { render, staticRenderFns } from "./RightBet.vue?vue&type=template&id=26082b02&scoped=true&"
import script from "./RightBet.vue?vue&type=script&lang=js&"
export * from "./RightBet.vue?vue&type=script&lang=js&"
import style0 from "./RightBet.vue?vue&type=style&index=0&id=26082b02&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26082b02",
  null
  
)

export default component.exports